import * as React from 'react';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import TreeDropdown from '@common/components/TreeDropdown';
import { getItem } from '@common/components/Tree';
import {getFolders, getQuestionnaires, checkPedigreeName, savePedigree, launchQuestionnaire} from "./actions/pedigree";
import {MessageBox} from "@common/components/MessageBox";
import { ErrorMessage } from '@common/components/error-message';
import { PEDIGREE_GENDER } from './const/pedigree';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { Radio } from '@common/components/radio';
import { FormControl } from '@common/components/form-control';
import './new-pedigree.styles.scss';

const Row = ({ children, className, ...otherProps }) => <div className={cx(className, "row")} {...otherProps}>{children}</div>;

const Col = ({ children, className, sm, smOffset, ...otherProps }) =>
    <div className={cx(className, `col-sm-${sm}`, `col-sm-offset-${smOffset}`)} {...otherProps}>{children}</div>;

class NewPedigreeComponent extends React.Component {

    state = {
        showProbandRelatives: false,
        showLaunchQuestionaire: false,
        pedigreeName: "",
        homeFolderId: this.props.currentFolderId,
        gender: 1,
        brothers: 0,
        sisters: 0,
        sons: 0,
        daughters: 0,
        paternalUncles: 0,
        paternalAunts: 0,
        maternalUncles: 0,
        maternalAunts:0,
        rowIsActiveId: 0,
        isFHQ4: false,
        isError: false,
        errors: [],
        folderError: null,
        messageProps: {
            header: 'ERROR',
            text: '',
            show: false,
            confirmText: 'Ok',
            cancelText: '',
            size: 'medium',
        }
    };

    focusTimeouts = [];
    debounceTimeout = null;

    componentDidMount() {
        this.initialize();
        this.focusInput();
    }

    componentWillUnmount() {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        if (this.focusTimeouts) {
            this.focusTimeouts.forEach(clearTimeout);
        }
    }

    componentDidUpdate(prevProps) {
        const { pedigree: prevPedigree } = prevProps;
        const { pedigree: currentPedigree, currentFolderId } = this.props;

        if (prevPedigree.folders.length === 0 && currentPedigree.folders.length > 0) {
            this.setState({
                homeFolderId: currentFolderId ?? currentPedigree.folders[0].id,
            });
        }
    }

    initialize = () => {
        this.props.getFolders().catch((err) => {
            this.showErrorMessage(err?.entity ?? I18n.t('Failed to load pedigree folders'));
        });
        this.props.getQuestionnaires();
    };

    focusInput = () => {
        const selector = '.NewPredigree input[type="text"]';
        const attemptDelays = [0, 50, 100, 200];

        this.focusTimeouts = attemptDelays.map((delay) =>
            setTimeout(() => {
                const input = document.querySelector(selector);
                const isNotFocused = input && document.activeElement !== input;

                if (isNotFocused) {
                    input.focus();
                }
            }, delay)
        );
    };

    handleShowProbandRelatives = () => {
        const folderError = this.getFolderValidationError();
        if (folderError) {
            this.setState({ folderError });
            return;
        }
        this.setState({ folderError: null });
        if(this.state.pedigreeName && this.state.pedigreeName.trim() !== ""){
            this.props.checkPedigreeName(this.state.homeFolderId, this.state.pedigreeName)
                .then(
                    (nameExists) => {
                        if(nameExists) {
                            this.setState({
                                errors: [...this.state.errors, I18n.t('Pedigree name already exists')],
                                isError: true
                            })
                        } else {
                            this.setState((state) => ({ ...state, showProbandRelatives: true }))
                        }
                    }
                )
                .catch((err) => {
                    console.error(err);
                    this.showErrorMessage(err?.entity ?? I18n.t('Failed to check pedigree name'));
                })
        } else {
            this.setState({
                errors: [...this.state.errors, I18n.t('Specify name of new pedigree')],
                isError: true
            })
        }
    }

    handleFolderName = (id) => {
        this.setState({
            homeFolderId: id,
            folderError: null
        })
    }

    getFolderValidationError = () => {
        const { folders } = this.props.pedigree;
        if (!folders || folders.length === 0) {
            return I18n.t('You do not have access to any folders');
        }
        if (!getItem(this.state.homeFolderId, folders)?.id) {
            return I18n.t('Please select a folder');
        }
        return null;
    }

    handleNewPedigree = (e) => {
        this.setState({
            pedigreeName: e.target.value,
            errors: [],
            isError: false
        })
    }

    processPedigreeName = (e) => {
        this.setState({
            pedigreeName: (e.target.value ?? '').trim(),
            errors: [],
            isError: false
        })
    }

    handleSetGender = (e) => {
        this.setState({
            gender: e.target.value
        })
    }

    handleAddProband = (e) => {
        e.persist();
        const value = e.target.value;
        const fieldId = e.target.id;
        
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        
        this.debounceTimeout = setTimeout(() => {
            const currentValue = this.state[fieldId];
            const newValue = value === '' ? 0 : Math.max(0, parseInt(value, 10));
            
            if (newValue !== currentValue) {
                this.setState({
                    [fieldId]: newValue
                });
            }
        }, 100);
    }

    handleShowNewPedigree = () => {
        this.setState((state) => ({ ...state, showProbandRelatives: false }));
    }

    handleShowLaunchQuestionnaire = () => {
        const folderError = this.getFolderValidationError();
        if (folderError) {
            this.setState({ folderError });
            return;
        }
        this.setState({ folderError: null });
        if(this.state.pedigreeName && this.state.pedigreeName.trim() !== ""){
            this.props.checkPedigreeName(this.state.homeFolderId, this.state.pedigreeName)
                .then(
                    (nameExists) => {
                        if(nameExists) {
                            this.setState({
                                errors: [...this.state.errors, I18n.t('Pedigree name already exists')],
                                isError: true
                            })
                        } else {
                            this.setState((state) => ({ ...state, showLaunchQuestionnaire: true }));
                        }
                    }
                )
                .catch((err) => {
                    console.error(err);
                    this.showErrorMessage(err?.entity ?? I18n.t('Failed to check pedigree name'));
                })
        } else {
            this.setState({
                errors: [...this.state.errors, I18n.t('Specify name of new pedigree')],
                isError: true
            })
        }
    }

    handleDrawNow = () => {
        const folderError = this.getFolderValidationError();
        if (folderError) {
            this.setState({ folderError });
            return;
        }
        this.setState({ folderError: null });
        if(this.state.pedigreeName && this.state.pedigreeName.trim() !== ""){
            this.props.checkPedigreeName(this.state.homeFolderId, this.state.pedigreeName)
                .then(
                    (nameExists) => {
                        if (nameExists) {
                            this.setState({
                                errors: [...this.state.errors, I18n.t('Pedigree name already exists')],
                                isError: true
                            })
                        } else {
                            let data = {
                                brothers: 0,
                                sisters: 0,
                                sons: 0,
                                daughters: 0,
                                paternalUncles: 0,
                                paternalAunts: 0,
                                maternalUncles: 0,
                                maternalAunts: 0,
                                name: this.state.pedigreeName,
                                gender: this.state.gender,
                                homeFolderId: parseInt(this.state.homeFolderId),
                                addProbandOnly: true,
                                markersFormatId: 0,
                                symbolsFormatId: 0,
                                subtextFormatId: 0
                            }
                            this.props.savePedigree(data, this.handleSaveClose);
                        }
                    }
                )
                .catch((err) => {
                    console.error(err);
                    this.showErrorMessage(err?.entity ?? I18n.t('Failed to check pedigree name'));
                })
        } else {
            this.setState({
                errors: [...this.state.errors, I18n.t('Specify name of new pedigree')],
                isError: true
            })
        }
    }

    handleQuestionnaireRowClick = (e) => {
        const targetId = e.currentTarget.id.split(', ');
        this.setState((state) => ({ ...state, rowIsActiveId: targetId[0], isFHQ4: targetId[1] }));
    }

    handleLaunchQuestionnaire = () => {
        let data = {
            brothers: 0,
            sisters: 0,
            sons: 0,
            daughters: 0,
            paternalUncles: 0,
            paternalAunts: 0,
            maternalUncles: 0,
            maternalAunts: 0,
            name: this.state.pedigreeName,
            gender: this.state.gender,
            homeFolderId: parseInt(this.state.homeFolderId),
            addProbandOnly: true,
            markersFormatId: 0,
            symbolsFormatId: 0,
            subtextFormatId: 0
        }
        launchQuestionnaire(this.state.rowIsActiveId, this.state.isFHQ4, data, this.handleSaveClose)
    }

    handleSubmit = () => {
         let data = {
            brothers: this.state.brothers,
            sisters: this.state.sisters,
            sons: this.state.sons,
            daughters: this.state.daughters,
            paternalUncles: this.state.paternalUncles,
            paternalAunts: this.state.paternalAunts,
            maternalUncles: this.state.maternalUncles,
            maternalAunts: this.state.maternalAunts,
            name: this.state.pedigreeName,
            gender: this.state.gender,
            homeFolderId: parseInt(this.state.homeFolderId),
            addProbandOnly: false,
            markersFormatId: -1,
            symbolsFormatId: -1,
            subtextFormatId: -1
        }
        this.props.savePedigree(data, this.handleSaveClose);
    }

    handleClose = () => {
        this.props.close();
    }

    handleSaveClose = (message) => {
        if (message === null) {
            this.props.close();
        } else {
            this.showMessage({text:message});
        }
    }

    setMessageProps = (props) => {
        this.setState((state) => ({
            ...state,
            messageProps: {
                ...state.messageProps,
                confirmText: 'Ok',
                cancelText: '',
                size: 'small',
                ...props,
            },
        }));
    }

    showMessage = (config) => {
        this.setMessageProps({
            ...config,
            show: true,
            onCustomOk: this.closeMessage,
        });
    }

    showErrorMessage = (msg) => {
        this.setMessageProps({
            header: I18n.t('Operation canceled'),
            content: <ErrorMessage>{msg}</ErrorMessage>,
            show: true,
            confirmText: 'Ok',
            onCustomOk: this.closeMessage,
        });
    }

    closeMessage = () => {
        this.setMessageProps({ show: false });
    }

    get probandRelatives() {
        return [
            { label: 'Brothers', id: 'brothers' },
            { label: 'Sisters', id: 'sisters' },
            { label: 'Sons', id: 'sons' },
            { label: 'Daughters', id: 'daughters' },
            { label: 'Paternal Uncles', id: 'paternalUncles' },
            { label: 'Paternal Aunts', id: 'paternalAunts' },
            { label: 'Maternal Uncles', id: 'maternalUncles' },
            { label: 'Maternal Aunts', id: 'maternalAunts' },
        ].map((x) => ({ ...x, label: I18n.t(x.label) }));
    }

    render() {
        const { showProbandRelatives, showLaunchQuestionnaire, pedigreeName, homeFolderId, errors, isError, folderError, rowIsActiveId, isFHQ4, gender } = this.state;
        const { pedigree } = this.props;

        return (
            <Modal
                show
                animation={false}
                className="NewPredigree"
                backdrop="static"
                bsClass="bootstrap modal"
                bsSize="large"
                dialogClassName="NewPredigree"
                onEscapeKeyDown={this.handleClose}
                onHide={this.handleClose}
                onEnter={this.clearData}
            >
                <ModalHeader closeButton onHide={this.handleClose}>
                    <ModalTitle id="btn-profile-header">{I18n.t("Add New Pedigree")}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <MessageBox
                        hideMessageBox={this.closeMessage}
                        {...this.state.messageProps}
                    />
                    <div className="NewPredigree__content">
                        {!showProbandRelatives && !showLaunchQuestionnaire &&
                            <div id="newFolder" className="NewPredigree__content__margined-section">
                                <Row>
                                    <Col sm={3} className="NewPredigree__content__form-label">
                                        {I18n.t("Folder Name:")}
                                    </Col>
                                    <Col sm={6}>
                                        <TreeDropdown
                                            id="folderName"
                                            className={cx('NewPredigree__content__folders', { 'input-error': !!folderError })}
                                            items={pedigree.folders}
                                            value={homeFolderId}
                                            onChange={this.handleFolderName}
                                        />
                                    </Col>
                                    {folderError && (
                                        <Col sm={6} className="error">
                                            {folderError}
                                        </Col>
                                    )}
                                </Row>
                                <Row>
                                    <Col sm={3} className="NewPredigree__content__form-label">
                                        {I18n.t("Pedigree Name:")}
                                    </Col>
                                    <Col sm={6}>
                                        <FormControl
                                            type="text"
                                            value={pedigreeName}
                                            onChange={this.handleNewPedigree}
                                            onBlur={this.processPedigreeName}
                                            className={errors.length > 0 ? 'input-error' : ''}
                                        />
                                    </Col>
                                    {errors.length > 0 && errors.map((error) => (
                                        <Col sm={6} className="error" key={error}>
                                            {error}
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    <Col sm={3} className="NewPredigree__content__form-label">
                                        {I18n.t("Sex")}:
                                    </Col>
                                    <Col sm={6}>
                                        <div>
                                            <Radio name="gender" value={PEDIGREE_GENDER.male} checked={PEDIGREE_GENDER.male == gender} defaultChecked onChange={this.handleSetGender}>
                                                {I18n.t("Male")}
                                            </Radio>{' '}
                                            <Radio name="gender" value={PEDIGREE_GENDER.female} checked={PEDIGREE_GENDER.female == gender} onChange={this.handleSetGender}>
                                                {I18n.t("Female")}
                                            </Radio>{' '}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        }
                        {showProbandRelatives && !showLaunchQuestionnaire &&
                            <div id="probandRelatives">
                                <Row>
                                    <Col sm={12} className="NewPredigree__content__form-label text-center">
                                        {I18n.t("Enter the number for each Proband relative:")}
                                    </Col>
                                </Row>
                                {this.probandRelatives.map((x) => (
                                    <Row key={x.id} className="NewPredigree__content__proband-relative">
                                        <Col sm={6} className="col-sm-3 col-sm-offset-4 NewPredigree__content__lh-35">
                                            {x.label}
                                        </Col>
                                        <Col sm={1}>
                                            <FormControl
                                                type="number"
                                                min={0}
                                                value={this.state[x.id]}
                                                id={x.id}
                                                className="NewPredigree__content__number-input"
                                                onChange={this.handleAddProband}
                                            />
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        }
                        {showLaunchQuestionnaire &&
                            <div className="questionaires">
                                <Row>
                                    <Col sm={10} smOffset={1} className="NewPredigree__content__form-label">
                                        {I18n.t('Select a Questionnaire')}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={10} smOffset={1}>
                                        <table className="table table-bordered table-condensed table-hover">
                                            <thead>
                                                <tr>
                                                    <th>{I18n.t("Questionnaire Name")}</th>
                                                    <th>{I18n.t("FHQ Version")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pedigree.questionnaires.map(questionnaire => (
                                                    <tr key={`${questionnaire.questionnaireId}, ${questionnaire.fhq4}`}
                                                        id={`${questionnaire.questionnaireId}, ${questionnaire.fhq4}`}
                                                        onClick={this.handleQuestionnaireRowClick}
                                                        className={parseInt(rowIsActiveId) === parseInt(questionnaire.questionnaireId) && String(isFHQ4) === String(questionnaire.fhq4) ? 'active' : ''}>
                                                        <td>
                                                            <img src="gif/questionnaire.gif"/> {questionnaire.questionnaireName}
                                                        </td>
                                                        <td>
                                                            {questionnaire.fhq4 ? 'FHQ4' : 'FHQ3'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Col sm={3} className="text-left">
                        <Button id="btn-new-pedigree-closed" onClick={this.handleClose}>
                            {I18n.t('Cancel')}
                        </Button>
                    </Col>
                    {!showProbandRelatives && !showLaunchQuestionnaire &&
                        <Col sm={9}>
                            <Button
                                id="btn-new-pedigree-launch-new-questionnaire"
                                onClick={this.handleShowLaunchQuestionnaire}
                                disabled={isError}
                            >
                                {I18n.t('Launch New Questionnaire')}
                            </Button>
                            <Button
                                id="btn-new-pedigree-draw-now"
                                onClick={this.handleDrawNow}
                                disabled={isError}
                            >
                                {I18n.t('Draw Now')}
                            </Button>
                            <Button
                                id="btn-new-pedigree-next"
                                bsStyle="primary"
                                onClick={this.handleShowProbandRelatives}
                                disabled={isError}
                            >
                                {I18n.t('Next')}
                            </Button>
                        </Col>
                    }
                    {showProbandRelatives && !showLaunchQuestionnaire &&
                        <Col sm={9}>
                            <Button
                                id="btn-new-pedigree-launch-new-questionaire"
                                onClick={this.handleShowNewPedigree}
                            >
                                {I18n.t('Previous')}
                            </Button>
                            <Button
                                id="btn-new-pedigree-next"
                                bsStyle="primary"
                                onClick={this.handleSubmit}
                            >
                                {I18n.t('Next')}
                            </Button>
                        </Col>
                    }
                    {showLaunchQuestionnaire &&
                        <Col sm={9}>
                            <Button
                                id="btn-new-pedigree-launch-questionnaire"
                                bsStyle="primary"
                                onClick={this.handleLaunchQuestionnaire}
                            >
                                {I18n.t('Launch Questionnaire')}
                            </Button>
                        </Col>
                    }
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = ({pedigree}) => {
    return {
        pedigree
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFolders: () => dispatch(getFolders()),
        getQuestionnaires: () => dispatch(getQuestionnaires()),
        checkPedigreeName,
        savePedigree: (data, handleSaveClose) => dispatch(savePedigree(data, handleSaveClose))
    };
};

export const NewPedigree = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewPedigreeComponent);